import { MenuItem, Select } from '@mui/material';
import { useCallback, useState } from 'react';
import Modal from 'react-modal';
import CustomButtonSimple from '../../../../components/CustomMiscellaneous/CustomButtonSimple';
import { IEntrega } from '../IObra';
import CloseIcon from '@mui/icons-material/Close';
import { generateFolhaObra } from '../../../../services/api.service';
import { TiposOperacoes } from '../../../../constants';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        display: 'flex',
        transform: 'translate(-50%, -50%)',
        overflow: 'auto',
        justifyContent: 'center'
    },
};

export function GenerateFolhaObraModal({ isOpen = false, obraId, entregas, onCancel }: { isOpen?: boolean, obraId: number, entregas: IEntrega[], onCancel: any }) {

    const [selectedEntrega, setSelectedEntrega] = useState<string>(entregas[0]?.id.toString());

    const [selectedPosto, setSelectedPosto] = useState<string>(TiposOperacoes[0]);

    const mutation = useMutation(()=> generateFolhaObra(`${obraId}`, selectedEntrega, selectedPosto),
    {
        onSuccess: ()=> console.log("Success"),
        onError: (e : any) => {
            console.log("Error: ", e);
            toast.error('Não existem peças para esta entrega que necessitem da operação selecionada')
        }
    }
    )

    

    return (
        <Modal isOpen={isOpen} style={customStyles}>
            <div className='w-[400px]'>
                <div className='flex justify-between mb-4'>
                    <div>Seleccione a entrega pretendida</div>
                    <CloseIcon onClick={onCancel} className="cursor-pointer"/>
                    </div>
                <div className='w-full mb-4'>
                    <Select
                        value={selectedEntrega}
                        label="Seleccione entrega"
                        placeholder='Seleccione entrega'
                        onChange={(e) => setSelectedEntrega(e.target.value)}
                        fullWidth
                    >
                        {entregas.map((e: IEntrega) => <MenuItem value={e.id}>{e.publicDeliveryDate.toString()}</MenuItem>)}

                    </Select>
                </div>

                <div className='w-full mb-4'>
                    <Select
                        value={selectedPosto}
                        label="Seleccione posto"
                        placeholder='Seleccione posto'
                        onChange={(e) => setSelectedPosto(e.target.value)}
                        fullWidth
                    >
                        {TiposOperacoes.map((e: string) => <MenuItem value={e}>{e}</MenuItem>)}

                    </Select>
                </div>
                <div className='flex justify-end'>
                    <CustomButtonSimple onClick={() => {
                        mutation.mutate()}} text="Confirmar" />
                </div>
            </div>
        </Modal>
    )


}